// Markup from design/kit/components/PageHeader.
import type { ReactNode } from 'react';
import { BellIcon } from './icons';

type PageHeaderProps = {
  title: string;
  // One line, no trailing period.
  subtitle?: string;
  // Page actions, primary last. The bell always comes after them.
  actions?: ReactNode;
};

export function PageHeader({ title, subtitle, actions }: PageHeaderProps) {
  return (
    <header className="row g12 wrap between">
      <div className="col g4">
        <h1 className="ptitle">{title}</h1>
        {subtitle && <p className="m0 t13 muted">{subtitle}</p>}
      </div>
      <div className="row g8 wrap">
        {actions}
        <Bell />
      </div>
    </header>
  );
}

export function Bell() {
  return (
    <span className="bell" role="img" aria-label="Notifications">
      <BellIcon />
    </span>
  );
}
